import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Select from 'react-select';

function TrappingRunForm({
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
  setFieldValue,
  isSubmitting,
  setFieldTouched,
  propertiesSelector,
  formOptions
}) {
  const display = propertiesSelector.display;
  const properties = propertiesSelector.properties;

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Form.Group controlId='name'>
        <Form.Label>
          {formOptions?.name?.label ? formOptions?.name?.label : 'Name'}
        </Form.Label>
        <Form.Control
          type='text'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          placeholder={
            formOptions?.name?.placeholder ? formOptions?.name?.placeholder : 'Name'
          }
          isInvalid={errors.name}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.name}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group>
        <Form.Label>
          {formOptions?.description?.label
            ? formOptions?.description?.label
            : 'Description'}
        </Form.Label>
        <Form.Control
          id='description'
          as='textarea'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.description}
          placeholder={
            formOptions?.description?.placeholder
              ? formOptions?.description?.placeholder
              : 'Description'
          }
        />
      </Form.Group>

      <Form.Group controlId='passcode'>
        <Form.Label>
          {formOptions?.passcode?.label
            ? formOptions?.passcode?.label
            : 'Passcode'}
        </Form.Label>
        <Form.Control
          type='text'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.passcode}
          placeholder='Passcode'
          isInvalid={errors.passcode}
          readOnly={formOptions?.passcode?.readOnly}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.passcode}
        </Form.Control.Feedback>
      </Form.Group>
      {display && (
        <Form.Group controlId='properties'>
          <Form.Label>
            {formOptions?.selectProperties?.label
              ? formOptions?.selectProperties?.label
              : 'Select Properties'}
          </Form.Label>
          <InputGroup>
            <Select
              value={values.properties}
              onChange={(options) => {
                setFieldValue('properties', options || []);
              }}
              options={properties.map((property) => {
                return {
                  value: property.id,
                  label: property.name
                };
              })}
              styles={{
                container: (styles) => ({
                  ...styles,
                  flex: '1 1 auto'
                })
              }}
              closeMenuOnSelect={false}
              isMulti
            />
          </InputGroup>
        </Form.Group>
      )}
    </Form>
  );
}

export default TrappingRunForm;
